import styled from 'styled-components';

export const Checkbox = styled.input.attrs({
  className: 'Checkbox',
  type: 'checkbox',
})`
  margin: 0 2px;
  cursor: pointer;
  accent-color: maroon;
`;

interface KeypointCollectionOptionContainerProps {
  isLabeled: boolean;
  isActive: boolean;
}

export const KeypointCollectionOptionContainer = styled.div.attrs({
  className: 'KeypointCollectionOptionContainer',
})<KeypointCollectionOptionContainerProps>(
  ({ isLabeled, isActive }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${isActive ? '#2a98e8' : isLabeled ? 'lightpink' : 'none'};
    &:hover {
      background: ${isActive ? '#2a98e8' : isLabeled ? 'pink' : 'none'};
    }
  `
);
